// extracted by mini-css-extract-plugin
module.exports = {"container":"Style_container__n5DgQ","comment":"Style_comment__LXfYa","scroll":"Style_scroll__uK-C5"};